/**
 * 리플레이 재생 길이 정책.
 *
 * 물리 시뮬레이션은 공이 완전히 멈출 때까지(최대 12초) 돌지만, 그걸 실시간으로
 * 다 보여주면 한 샷에 10초씩 멈춰 있게 된다. 그래서 재생은 상한을 두고,
 * 긴 샷은 배속으로 넘긴다 — 결과는 그대로이고 보는 시간만 줄어든다.
 *
 * 서버/로컬 양쪽이 이 함수를 공유해야 "재생이 끝나면 다음 턴" 타이밍이 어긋나지 않는다.
 */
export const MAX_REPLAY_MS = 6_000;

function rawDurationMs(frameCount: number, sampleHz: number): number {
  return (frameCount / Math.max(1, sampleHz)) * 1000;
}

/** 실제로 화면에 재생될 시간 (ms). */
export function replayDurationMs(frameCount: number, sampleHz: number): number {
  return Math.min(MAX_REPLAY_MS, rawDurationMs(frameCount, sampleHz));
}

/** 재생 배속. 짧은 샷은 1배속, 긴 샷은 상한에 맞춰 빨라진다. */
export function replaySpeed(frameCount: number, sampleHz: number): number {
  const raw = rawDurationMs(frameCount, sampleHz);
  return raw <= MAX_REPLAY_MS ? 1 : raw / MAX_REPLAY_MS;
}
